import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

// Disable all console logs in production
if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const router = createRouter({ routeTree });

import { AuthProvider } from './context/AuthProvider'
import { UserSettingsProvider } from './context/UserSettingsProvider'

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <UserSettingsProvider>
        <RouterProvider router={router} />
      </UserSettingsProvider>
    </AuthProvider>
  </StrictMode>
);
